import { render, staticRenderFns } from "./FormWelcome.vue?vue&type=template&id=3640f23f&scoped=true"
import script from "./FormWelcome.vue?vue&type=script&lang=js"
export * from "./FormWelcome.vue?vue&type=script&lang=js"
import style0 from "./FormWelcome.vue?vue&type=style&index=0&id=3640f23f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3640f23f",
  null
  
)

export default component.exports